import { Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * Aviso modal do cardapio digital — canal UNICO para mensagens ao cliente.
 *
 * Dialogo e nao toast: o `MessageService` desta tela nao renderiza nada, mesmo com
 * `providers: [MessageService]` e `<p-toast>` no template (verificado em runtime, disparando
 * `add()` direto da instancia). E generico para nao virar um dialogo por caso de uso.
 *
 * Visual de `cardapio-loja-fechada-dialog` (classes globais `cardapio-info-dialog` /
 * `cardapio-info-mask`).
 */
@Component({
  selector: 'app-cardapio-aviso-dialog',
  templateUrl: './cardapio-aviso-dialog.component.html',
  styleUrls: ['./cardapio-aviso-dialog.component.scss'],
})
export class CardapioAvisoDialogComponent {
  @Input() visible = false;
  /** Textos ja traduzidos — quem chama resolve a i18n. */
  @Input() titulo = '';
  @Input() mensagem = '';
  @Input() textoBotao = '';
  /** Classe do icone PrimeIcons exibida no cabecalho. */
  @Input() icone = 'pi pi-exclamation-triangle';

  @Output() visibleChange = new EventEmitter<boolean>();

  onHide(): void {
    this.visibleChange.emit(false);
  }

  fechar(): void {
    this.visible = false;
    this.visibleChange.emit(false);
  }
}
